/* FR — Français. Glossaire : Lumière / Ténèbres · obscurité / Aube /
   Nuit éternelle / Sanctuaire / Relique / Profondeur / Étincelle.
   Valeurs en guillemets doubles (nombreuses apostrophes). */
export const fr = {
  ui: {
    'html.rotate': "Tournez l'appareil<br>en mode paysage",

    'hud.level': "NV {n}",
    'hud.gold': "{gem} {n}",
    'hud.eternalNight': "{spark} NUIT ÉTERNELLE",
    'hud.lightPower': "{bolt} DÉGÂTS ×1.6 · {s}s",
    'hud.boss': "BOSS",
    'hud.coreLabel': "NOYAU",
    'hud.heatLabel': "chaleur · lumière {n}%",
    'hud.poleLo': "FUREUR +{n}%",
    'hud.poleHi': "AUBE +{n}%",

    'banner.cache': "CACHE — or et éclair de lumière",
    'banner.font': "SOURCE — soin et force de dégâts",
    'banner.relic': "RELIQUE — {name}",
    'banner.bossDown': "{name} VAINCU",
    'banner.darkFork': "CARREFOUR DES TÉNÈBRES",
    'banner.eliteWave': "PERCÉE DES OMBRES",
    'banner.heattide': "MARÉE DE CHALEUR",
    'banner.anomaly': "TÉNÈBRES : {name}",
    'banner.evolution': "ÉVOLUTION — {name}",
    'banner.synergy': "SYNERGIE — {name}",
    'banner.forge': "FORGE — {name}",
    'banner.overclock': "SURCHAUFFE — {name}",
    'banner.enrage': "{name} — FUREUR",
    'banner.snare': "PIÈGE — TIENS LA ZONE !",
    'banner.snareWin': "FOYER ALLUMÉ !",
    'banner.snareDefend': "FOYER — DÉFENDS !",
    'banner.snareDefendWin': "FOYER TENU !",
    'banner.snareFail': "FOYER ÉTEINT !",
    'banner.snareWaveCleared': "VAGUE REPOUSSÉE",
    'hud.snareWave': "vague {n}/{total}",
    'hud.snareNextWave': "vague suivante",
    'banner.revive': "SECOND SOUFFLE",
    'banner.dawn': "{spark} A U B E {spark}",

    'menu.tagline': "Grandis. Ou refroidis.",
    'menu.subtitle': "S U R V I V O R S",
    'menu.start': "{play} JOUER",
    'menu.shop': "{gem} BOUTIQUE",
    'menu.moveKeyboard': "WASD / flèches — déplacement      les armes tirent seules",
    'menu.moveTouch': "glisse le doigt — déplacement      les armes tirent seules",
    'menu.hintCollect': "ramasse les étincelles → niveau → choisis une amélioration",
    'menu.hintDawn': "survis jusqu'à l'Aube (10:00) → puis nuit éternelle. va vers la {spark} lumière au loin",
    'menu.best': "meilleure partie : {time}",
    'menu.depthStat': "profondeur : {n}/{total}",
    'menu.codexStat': "codex : {n}/{total}",
    'menu.settings': "{gear} PARAMÈTRES",

    'charselect.title': "CHOISIS TON ÉTINCELLE",
    'charselect.controls': "← →  choisir   ·   Entrée / clic — au combat",
    'charselect.locked': "???",
    'charselect.lockedFallback': "verrouillé",
    'charselect.surface': "Surface",
    'charselect.depthTitle': "PROFONDEUR DES TÉNÈBRES   ( ↑ ↓  ou clic ◂ ▸ )",
    'charselect.pathTitle': "VOIE   ( Q E  ou clic ◂ ▸ )",
    'charselect.depthReward': "{desc}   ·   récompense ×{mult}",
    'charselect.depthLocked': "survis jusqu'à l'Aube (10:00) — débloque la Profondeur des Ténèbres (plus de menaces et de récompenses)",

    'shop.title': "BOUTIQUE DE LUMIÈRE",
    'shop.back': "← RETOUR",
    'shop.controls': "↑ ↓  choisir   ·   Entrée / clic — acheter   ·   Esc / M — retour",
    'shop.max': "MAX",
    'shop.trackForge': "FORGE",
    'shop.trackHearth': "CREUSET",

    'draft.shrineTitle': "{spark} SANCTUAIRE {spark}",
    'draft.eventTitle': "CARREFOUR DES TÉNÈBRES",
    'draft.anomalyTitle': "{moon} SERMENT DES TÉNÈBRES {moon}",
    'draft.levelTitle': "NIVEAU {n}",
    'draft.shrineHint': "choisis une relique  ·  permanent pour la partie  ·  1 / 2 / 3",
    'draft.eventHint': "choisis une voie  ·  pas de bonne réponse  ·  1 / 2 / 3",
    'draft.anomalyHint': "façonne cette nuit  ·  sans retour  ·  encore {n}",
    'draft.levelHint': "choisis une amélioration  ·  1 / 2 / 3  ou  clic",
    'draft.reroll': "{cycle} relancer  ·  R  ·  une fois par partie",
    'draft.snareTitle': "PIÈGE — TIENS LA ZONE",
    'draft.snareHint': "choisis un appui  ·  reste dans la zone — l'attisage monte  ·  1 / 2 / 3",
    'draft.snareDefendTitle': "FOYER — DÉFENDS",
    'draft.snareDefendHint': "choisis un appui  ·  défends le cœur de la nuée  ·  1 / 2 / 3",
    'draft.new': "NOUVEAU",
    'draft.lvlChange': "Nv {a} → {b}",

    'kind.event': "CARREFOUR",
    'kind.evolve': "{star} ÉVOLUTION {star}",
    'kind.anomaly': "{moon} SERMENT",
    'kind.relic': "{spark} RELIQUE",
    'kind.weapon': "ARME",
    'kind.passive': "PASSIF",
    'kind.bonus': "BONUS",
    'kind.boon': "APPUI",
    'kind.forge': "FORGE",
    'kind.overclock': "SURCHAUFFE",
    'forge.ocName': "Surchauffe : {w}",
    'forge.ocDesc': "Au-delà du palier 5 — puissance contre lumière. +{dmg}% dégâts · −{cost} lumière · palier {n}/{max}",

    'heal.name': "Soin",
    'heal.desc': "Restaure 25% des PV",

    'pause.title': "PAUSE",
    'pause.stats': "Nv {lvl}   ·   {time}   ·   {skull} {kills}   ·   lumière {light}",
    'pause.weapons': "ARMES",
    'pause.passives': "PASSIFS",
    'pause.relics': "RELIQUES",
    'pause.synergies': "SYNERGIES",
    'pause.victory': "{spark} PARTIR AVEC L'AUBE — VICTOIRE (V)",
    'pause.resume': "{play} REPRENDRE (ESC)",
    'pause.quit': "AU MENU (Q)",
    'pause.settings': "{gear} PARAMÈTRES",

    'settings.title': 'PARAMÈTRES',
    'settings.back': '← RETOUR',
    'settings.volume': 'VOLUME',
    'settings.crt': 'EFFET RÉTRO-CRT',
    'settings.language': 'LANGUE',
    'settings.on': 'ON',
    'settings.off': 'OFF',

    'results.dead': "TU ES TOMBÉ",
    'results.finale': "LES PROFONDEURS SONT VAINCUES",
    'results.survived': "TU AS SURVÉCU !",
    'results.finaleSub': "{star} Les ténèbres ne sont plus. Tu es l'Aube éternelle. {star}",
    'results.winSub': "La lumière a vaincu les ténèbres. Tu es devenu l'aube.",
    'results.demoTitle': "DÉMO TERMINÉE",
    'results.demoSub': "Version complète : Profondeurs des Ténèbres · 2es phases de boss · héros, armes & voies",
    'results.time': "Survie",
    'results.level': "Niveau",
    'results.kills': "Éliminations",
    'results.bosses': "Boss",
    'results.score': "Score",
    'results.gold': "Or",
    'results.relics': "RELIQUES",
    'results.unlocked': "{spark} DÉBLOQUÉ : {names}",
    'results.restart': "{play}  ESPACE / CLIC  —  REJOUER",
    'results.menu': "M  /  clic  —  menu et boutique",

    'speak.continue': "clic / espace — continuer",

    'rarity.rare': "RARE",
    'rarity.legend': "LÉGENDAIRE",

    'unit.dmg': "dégâts",
    'unit.speed': "vitesse",
    'unit.enemySlow': "vitesse ennemie",
    'unit.regen': "PV/s",
    'unit.radius': "rayon de ramassage",
    'unit.hp': "PV max",
    'unit.crit': "chance critique",
    'unit.cooldown': "recharge",
    'unit.leech': "PV par élim.",
  },

  data: {
    enemies: {
      chaser: { name: "Ombre" }, swarm: { name: "Feu follet" }, tank: { name: "Fardeau" },
      spitter: { name: "Cracheur" }, devourer: { name: "Dévoreur" }, splitter: { name: "Fragmenteur" },
      splitling: { name: "Éclat" }, anchor: { name: "Ancre" }, leech: { name: "Disperseur" },
      brute: { name: "Colosse" }, boss: { name: "Faucheur" }, boss2: { name: "Éclipse" },
      boss3: { name: "Seigneur de l'Éclipse" }, boss4: { name: "Point Zéro" },
      diver: { name: "Fonceur" }, sniper: { name: "Dard" }, boss5: { name: "Titan" },
    },
    characters: {
      spark:  { name: "Étincelle", desc: "Équilibre en tout. Débute avec : Trait." },
      ember:  { name: "Braise",    desc: "Canon de verre : +25% de dégâts, mais moins de PV et de chaleur. Débute avec : Trait." },
      umbra:  { name: "Couvant",   desc: "Brûle vif mais bref : la chaleur s'éteint, chaque mort offre un instant. Débute avec : Trait." },
      mirror: { name: "Retourné",  desc: "La chaleur naît des morts ; les dégâts l'éteignent. Débute avec : Sphère ardente." },
    },
    shop: {
      maxhp:  { name: "Trempe",         desc: "+12 PV max par niveau" },
      power:  { name: "Fureur",         desc: "+5% de dégâts par niveau" },
      speed:  { name: "Vivacité",       desc: "+4% de vitesse par niveau" },
      light:  { name: "Éclat",          desc: "+20 de chaleur par niveau" },
      revive: { name: "Second souffle", desc: "Renaître une fois à la mort" },
      reroll:  { name: "Charbon de plus",    desc: "+1 remélange de draft par partie" },
      beacons: { name: "Mémoire des sanctuaires", desc: "Les sanctuaires brûlent plus souvent" },
      trove:   { name: "Reliquaire",         desc: "+1 relique dans le choix des sanctuaires" },
      anoma:   { name: "Forge d'anomalies",  desc: "+1 choix de Serment des Ténèbres au départ" },
    },
    weapons: {
      bolt:      { name: "Trait",           desc: "Un trait de chaleur frappe le plus proche" },
      orbit:     { name: "Sphère ardente",  desc: "Des sphères de chaleur tournent autour de toi" },
      nova:      { name: "Déflagration",    desc: "Une onde de chaleur autour de toi" },
      whip:      { name: "Fouet",           desc: "Un coup tranchant dans ta direction" },
      chain:     { name: "Traînée de feu",  desc: "Le feu bondit entre les ennemis" },
      mine:      { name: "Tison",           desc: "Un tison couvant s'embrase près d'un ennemi" },
      beam:      { name: "Rayon ardent",    desc: "Un jet brûlant continu dans ta ligne de visée" },
      lantern:   { name: "Forge",           desc: "Pose une zone de chaleur : freine et brûle" },
      duskblade: { name: "Lame de cendre",  desc: "Une lame de cendre : frappe plus fort quand ta chaleur faiblit" },
      ricochet:  { name: "Ricochet",        desc: "Un éclat ricoche sur les ténèbres et gagne en chaleur" },
      dawnflash: { name: "Explosion",       desc: "Ultime : une explosion de chaleur sur tout l'écran" },
    },
    evolutions: {
      dawnray:      { name: "Salve",             desc: "Une salve d'étincelles à tête chercheuse qui transpercent" },
      corona:       { name: "Couronne",          desc: "Un anneau de sphères ardentes tourne autour de toi" },
      supernova:    { name: "Embrasement",       desc: "Une onde de chaleur dévastatrice sur tout l'écran" },
      solaredge:    { name: "Éventail de fouet", desc: "Tranche dans toutes les directions à la fois" },
      tempest:      { name: "Tempête de feu",    desc: "Le feu frappe tous les proches à la fois" },
      beacon:       { name: "Champ de braises",  desc: "Un champ de pièges de braise explosifs" },
      sunlance:     { name: "Percée ardente",    desc: "Un large jet de chaleur transperce un rang entier" },
      lighthouse:   { name: "Brasero",           desc: "Une zone de chaleur colossale — une forteresse tient la nuit" },
      eclipseblade: { name: "Éventail de cendre",desc: "Un éventail de lames de cendre transperce le rang" },
      prism:        { name: "Prisme",            desc: "Un jet se divise et ricoche sans fin" },
      daybreak:     { name: "Éruption",          desc: "Une éruption de chaleur sur tout l'écran aveugle les ténèbres" },
    },
    passives: {
      speed:  { name: "Accélération",        desc: "+vitesse de déplacement" },
      power:  { name: "Puissance",           desc: "+tous les dégâts" },
      regen:  { name: "Régénération",        desc: "+récupération de PV" },
      magnet: { name: "Aimant",              desc: "+rayon de ramassage" },
      vigor:  { name: "Vigueur",             desc: "+PV max" },
      crit:   { name: "Précision",           desc: "Chance de coup critique (×2.2)" },
      haste:  { name: "Tir rapide",          desc: "−temps de recharge de toutes les armes" },
      leech:  { name: "Moisson de chaleur",  desc: "Soigne des PV par élimination" },
      bloom:  { name: "Éclosion",            desc: "Les morts explosent de chaleur" },
      frost:  { name: "Givre",               desc: "Une aura ralentit les ténèbres autour de toi" },
      pulse:  { name: "Pulsation de chaleur",desc: "Coup reçu → une onde de chaleur" },
    },
    forgeMods: {
      bolt_core:     { name: "Cœur incandescent", desc: "L'Impulsion frappe plus fort (+35%) et transperce 1 cible" },
      bolt_shrapnel: { name: "Shrapnel",          desc: "Éclate en salve : +2 projectiles, chacun plus faible — un tapis de feu" },
      bolt_armor:    { name: "Perce-armure",      desc: "Une seule tige lourde : transperce tout le rang, mais moins de projectiles" },
      orbit_core:    { name: "Anneau incandescent", desc: "Les sphères brûlent plus fort (+30%) et l'anneau est plus large — plus de contact" },
      orbit_swarm:   { name: "Nuée d'étincelles",   desc: "+2 sphères, chacune plus faible — un carrousel dense" },
      orbit_one:     { name: "Mort d'un seul",      desc: "Une sphère de moins, mais lourde : ×1.9 de dégâts et plus grande" },
      whip_core:     { name: "Coup forgé",          desc: "Le coup frappe plus fort (+30%) et repousse davantage" },
      whip_sweep:    { name: "Grand balayage",      desc: "Arc 70% plus large et balaie deux fois plus fort — contrôle de foule, plus faible par cible" },
      whip_harpoon:  { name: "Harpon",              desc: "Une longue lance étroite : deux fois la portée et plus lourde, mais une fine bande" },
      bolt_split:    { name: "Éclatement en vol",   desc: "À l'impact, l'Impulsion se scinde en 2 éclats autoguidés" },
      whip_grasp:    { name: "Emprise",             desc: "Le fouet ATTIRE les ennemis dans la bordure de chaleur au lieu de les repousser" },
    },
    relics: {
      ember:    { name: "Braise de l'aube", desc: "+22% de dégâts en permanence" },
      bulwark:  { name: "Rempart",          desc: "+45 PV max, +0,8 PV/s" },
      swift:    { name: "Coursier",         desc: "+14% de vitesse, ×1,8 aimant" },
      radiance: { name: "Éclat",            desc: "+90 de rayon de chaleur" },
      overload: { name: "Surcharge",        desc: "Les armes tirent 18% plus vite" },
      famine:   { name: "Soif",             desc: "Soigne 0,9 PV par élimination" },
      thorns:   { name: "Couronne de courroux", desc: "La chaleur brûle sans cesse les ennemis autour de toi" },
      greed:    { name: "Avidité",          desc: "×1,6 d'or jusqu'à la fin de la partie" },
      umbralward: { name: "Furie des braises", desc: "Plus la chaleur baisse, plus tu frappes fort : jusqu'à +60% dans le noir" },
      dawncrown:  { name: "Couronne d'aube",   desc: "Plus la chaleur s'étend, plus tu frappes fort : jusqu'à +45% en pleine lumière" },
    },
    depths: {
      0: { name: "Profondeur I",   desc: "Le froid s'épaissit. La chaleur faiblit." },
      1: { name: "Profondeur II",  desc: "Ennemis plus coriaces, la nuit plus proche." },
      2: { name: "Profondeur III", desc: "La chaleur tient à peine." },
      3: { name: "Profondeur IV",  desc: "L'abîme te regarde en retour." },
      4: { name: "Profondeur V",   desc: "Seule l'aube peut te sauver." },
      5: { name: "Profondeur VI",  desc: "La fin de la chaleur." },
    },
    anomalies: {
      twilight:  { name: "Crépuscule",      desc: "Rayon de chaleur −22%" },
      longnight: { name: "Longue nuit",     desc: "Les coups éteignent plus de chaleur" },
      swarmtide: { name: "Marée d'essaim",  desc: "Deux fois plus de petites créatures" },
      frenzy:    { name: "Frénésie",        desc: "Ennemis plus rapides, mais plus d'or" },
      gloom:     { name: "Pénombre",        desc: "Aimant plus faible, mais XP plus riche" },
      embertide: { name: "Attisé",          desc: "La chaleur croît plus vite, mais le froid presse" },
      famine:    { name: "Famine",          desc: "Les ténèbres enfantent de plus grandes créatures" },
      fragile:   { name: "Fragilité",       desc: "Les ennemis frappent plus fort mais meurent plus vite" },
      embervow:  { name: "Vœu de cendre",   desc: "La chaleur se resserre, mais la fureur grandit dans le noir" },
    },
    darkEvents: {
      eliteWave: { name: "Percée des ombres",   desc: "Une vague de créatures coriaces d'un coup — mais une pluie d'or généreuse" },
      curse:     { name: "Densité des ténèbres", desc: "Une nouvelle règle sombre jusqu'à la fin — en échange, +15% de dégâts en permanence" },
      respite:   { name: "Accalmie",            desc: "Dissipe le froid proche, +50% PV, la chaleur s'embrase" },
      fortune:   { name: "Aubaine",             desc: "Une pluie d'or généreuse et un peu de santé" },
      heattide:  { name: "Marée de chaleur",    desc: "La chaleur déborde : ×1,5 dégâts pendant un temps et une poussée de rayon" },
      rift:      { name: "Faille",              desc: "Laisse tomber une relique — mais la faille laisse entrer le froid" },
    },
    shrineKinds: {
      relic: { name: "Sanctuaire" }, cache: { name: "Cache" }, font: { name: "Source" }, snare: { name: "Piège" },
    },
    snareBoons: {
      bulwark:  { name: "Rempart",   desc: "−55% de dégâts subis pendant le maintien" },
      overheat: { name: "Surchauffe", desc: "Les armes tirent ×2 plus vite, +25% de dégâts" },
      pulsar:   { name: "Pulsar",    desc: "Des ondes de chaleur repoussent et brûlent l'essaim" },
    },
    synergies: {
      ashEcho:      { name: "Écho de cendre" },
      darkForge:    { name: "Forge des ténèbres" },
      smolderfield: { name: "Champ couvant" },
      sunPillar:    { name: "Pilier solaire" },
      heatCorona:   { name: "Couronne de chaleur" },
      dawnSalvo:    { name: "Salve de l'aube" },
      fireWhirl:    { name: "Tourbillon de feu" },
    },
    paths: {
      wanderer: { name: "Vagabond",          desc: "Un début simple — la voie est ouverte, sans vœu." },
      ash:      { name: "Voie de la cendre", desc: "Build sombre dès le départ : commence sous le Vœu de cendre avec la Furie des braises." },
      dawn:     { name: "Voie de l'aube",    desc: "Build lumineux dès le départ : commence avec la Couronne d'aube et une chaleur constante." },
      swarm:    { name: "Voie de la nuée",   desc: "Contre la masse : commence avec la Traînée de feu et un Aimant." },
    },
    unlocks: {
      beam:      { hint: "Survis jusqu'à 4:00" },
      lantern:   { hint: "Vaincs le premier boss" },
      duskblade: { hint: "Tue 1500 créatures (au total)" },
      ricochet:  { hint: "Atteins le niveau 14 dans une partie" },
      dawnflash: { hint: "Atteins l'Aube (10:00)" },
      umbra:     { hint: "Vaincs un boss" },
      mirror:    { hint: "Entre dans la Profondeur des Ténèbres" },
      ash:       { hint: "Vaincs le premier boss" },
      swarm:     { hint: "Tue 2000 créatures (au total)" },
      dawn:      { hint: "Atteins l'Aube (10:00)" },
      shrines:   { hint: "Débloqué : Sanctuaires — des phares au loin gardent des reliques, atteins-les" },
      events:    { hint: "Débloqué : Embranchements des ténèbres — un choix-risque sans bonne réponse" },
      anomalies: { hint: "Débloqué : Vœu des ténèbres — choisis quelle obscurité devient la partie" },
    },
  },

  // Lore CHAMP DE CENDRES (§14) — fragments-voix. Iceberg : nomme un état/une image, n'explique jamais.
  lore: {
    runNames: [
      "La Dernière Chaleur", "Cendre du Troisième", "Le Coin Qui Se Souvient", "Avant la Première Couche",
      "Le Brasier d'un Autre", "L'Endroit Plat", "Avant de Devenir une Raie", "Sous le Froid",
      "Où la Forme Finit", "Plus Chaud qu'Avant", "Empreinte", "Couche Zéro",
    ],
    death: [
      "La chaleur s'en va plus vite que tu ne crois.",
      "Plus aigu d'abord. Puis lisse. Puis rien.",
      "Les bords en premier.",
      "La cendre ne se souvient pas de ce qu'elle fut.",
      "La forme a tenu plus longtemps qu'elle ne devait.",
      "Quelque part ici, tu as commencé à ressembler à tout le reste.",
      "La dernière chose à partir, c'est le nom.",
      "Refroidir, c'est consentir.",
      "Tu brûlais plus chaud qu'eux. Ça n'a pas suffi.",
      "La géométrie s'est refermée.",
      "Quelqu'un a brûlé ici avant toi. Loin, lui aussi.",
      "Pas éteint. Juste — indistinct.",
    ],
    shrineRelic: [
      "Quelqu'un l'a tenu tant que c'était encore chaud.",
      "Pas ta forme. Mais — de la chaleur.",
      "Ils brûlaient autrement. Voilà ce qui reste.",
    ],
    shrineCache: [
      "Rangé avec soin. Comme si on comptait revenir.",
      "De la cendre partout. Pas ici.",
      "Pas abandonné. Caché.",
    ],
    shrineFont: [
      "D'où vient la chaleur — on ne sait pas. Elle vient, c'est tout.",
      "Ici la forme tient d'elle-même.",
      "Plus profond, plus chaud. Ça aurait dû rassurer.",
    ],
    victory: [
      "Tu es sorti. Ou on t'a laissé sortir.",
      "Tu n'as jamais brûlé aussi profond.",
      "Tu n'as pas refroidi. Ça a suffi.",
    ],
    menuEarly: [
      "Tu n'as pas atteint l'endroit où la forme commence à changer.",
      "Une étincelle. Juste une étincelle, pour l'instant.",
    ],
    menuDeep: [
      "Tu n'es jamais allé aussi profond. La cendre est différente ici.",
    ],
    menuStreak: [
      "Tant de fois refroidi. Et tu brûles encore.",
      "Trois fois aussi loin. Quelqu'un le voit.",
    ],
    menuReturn: [
      "Te revoilà. Le Champ de Cendres n'est pas surpris.",
    ],
    menuDefault: [
      "Soit c'est de la force. Soit tu ne vois pas la différence.",
      "De nouveau chaud. C'est déjà ça.",
    ],
  },
};
